<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "App",
  
};
</script>

<style>
/* 这边路径简写（在vue.config.js配置了） */
@import "assets/css/base.css";
</style>
